module.exports = __webpack_public_path__ + "static/adedeji-eadd81bd7eb0b8fbdb39a27296c5b285.jpg";